var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWashbasinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.04 13.9782H16.6836V7.02546C16.6836 6.26909 17.2945 5.65819 18.0509 5.65819C18.8073 5.65819 19.4182 6.26909 19.4182 7.02546V9.09091C19.4182 9.46909 19.7236 9.77455 20.1018 9.77455C20.48 9.77455 20.7855 9.46909 20.7855 9.09091V7.02546C20.7855 5.51273 19.5491 4.27637 18.0364 4.27637C16.5236 4.27637 15.2873 5.51273 15.2873 7.02546V9.77455H13.92V9.09091C13.92 8.71273 13.6145 8.40728 13.2364 8.40728C12.8582 8.40728 12.5527 8.71273 12.5527 9.09091V11.84C12.5527 12.2182 12.8582 12.5236 13.2364 12.5236C13.6145 12.5236 13.92 12.2182 13.92 11.84V11.1564H15.2873V13.9927H4.96C4.58182 13.9927 4.27637 14.2982 4.27637 14.6764C4.27637 15.0545 4.58182 15.36 4.96 15.36H5.71637C6.06546 19.3164 9.28 23.6073 13.2364 23.6073H18.7346C22.6909 23.6073 25.92 19.3309 26.2546 15.36H27.0109C27.3891 15.36 27.6946 15.0545 27.6946 14.6764C27.6946 14.2982 27.4182 13.9782 27.04 13.9782Z",
    fill: "#C0C8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9345 25.6582C13.9345 26.7928 14.8654 27.7237 16 27.7237C17.1345 27.7237 18.0654 26.7928 18.0654 25.6582V24.9746H13.9345V25.6582Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashbasinIcon);
export default __webpack_public_path__ + "static/media/washbasin_icon.1990ecac48c9395024a9fbe96b008fb2.svg";
export { ForwardRef as ReactComponent };